module.exports = __webpack_public_path__ + "img/durocher_svg_V5.10fa933f.svg";